import { useState, useEffect } from 'react'

interface VersionInfo {
  version: string
  build: number
  buildDate: string
}

interface EnvironmentInfo {
  environment: string
  host: string
  catalog_role?: string
}

/**
 * Build number (stamped into /version.json at image build time) plus the deployment
 * environment this portal is served by (/api/tenant/environment). The footer shows the
 * environment name whenever it is not production, so nobody mistakes a QA or regional
 * portal for the production one.
 */
export function useVersion() {
  const [versionInfo, setVersionInfo] = useState<VersionInfo | null>(null)
  const [environment, setEnvironment] = useState<EnvironmentInfo | null>(null)

  useEffect(() => {
    fetch('/version.json')
      .then((res) => res.json())
      .then((data) => setVersionInfo(data))
      .catch(() => {
        // Fallback if version.json is not available
        setVersionInfo({ version: '0.0.0', build: 0, buildDate: '' })
      })
    fetch('/api/tenant/environment')
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => data && setEnvironment(data))
      .catch(() => setEnvironment(null))
  }, [])

  const formatVersion = () => {
    if (!versionInfo) return ''
    const base = `v${versionInfo.version} (build ${versionInfo.build})`
    if (environment && environment.environment && environment.environment !== 'production') {
      return `${base} · ${environment.environment}`
    }
    return base
  }

  return { versionInfo, environment, formatVersion }
}
